import { StateCreator } from 'zustand'
import { CampaignCreationState } from '../state'
import { TelegramPostType } from '@/shared/types'

export interface Step2Slice {
    telegramLinkToAdvertize: string
    telegramLinkToAdvertizeError: boolean
    telegramPostToAdvertize: TelegramPostType | null
    setTelegramLinkToAdvertize: (link: string) => void
    setTelegramLinkToAdvertizeError: (error: boolean) => void
    setTelegramPostToAdvertize: (post: TelegramPostType) => void
}

export const createStep2Slice: StateCreator<
    CampaignCreationState,
    [],
    [],
    Step2Slice
> = (set) => ({
    telegramLinkToAdvertize: '',
    telegramLinkToAdvertizeError: false,
    telegramPostToAdvertize: null,
    setTelegramLinkToAdvertize: (link) =>
        set({ telegramLinkToAdvertize: link }),
    setTelegramLinkToAdvertizeError: (error) =>
        set({ telegramLinkToAdvertizeError: error }),
    setTelegramPostToAdvertize: (post) =>
        set({ telegramPostToAdvertize: post }),
})
